import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TraceLineDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    icon: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    container: {
        alignSelf: "flex-start",
        alignItems: "center",
        flexDirection: "row",
        maxWidth: "100%",
        flexShrink: 1,
        minWidth: 0
    },
    connector: {
        position: "absolute"
    },
    description: {
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 0
    },
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    isInteractive,
    isConnected,
    iconSizes,
    rowHeight,
    borders,
    colors,
    spaces
}: TraceLineDynamicStyleType) => {
    const styles = {
        connector: {
            height: rowHeight - iconSizes.small - spaces.spacingXxs * 2,
            top: (rowHeight + iconSizes.small) / 2 + spaces.spacingXxs,
            start: (iconSizes.small - borders.separator) / 2,
            backgroundColor: colors.content.border.subtle,
            width: borders.separator
        } as Mutable<ViewStyle>,
        container: {
            minHeight: isInteractive ? undefined : rowHeight,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        description: {
            marginStart: spaces.spacingXs
        } as Mutable<ViewStyle>,
        icon: {
            height: iconSizes.small,
            width: iconSizes.small
        } as Mutable<ViewStyle>
    };

    if(isInteractive) {
        Object.assign(styles.container, {
            alignSelf: "center"
        });
    }

    if(!isConnected) {
        Object.assign(styles.connector, {
            display: "none"
        });
    }

    return styles;
};
export default stylesheet;
